import React from "react";
import "./HeroOther.css";
import PropTypes from "prop-types";

function HeroOther({ title }) {
  HeroOther.propTypes = {
    title: PropTypes.string.isRequired, // Replace `object` with the correct type
  };
  return (
    <div className="bg-[#eef4f9]">
      <div className="hero-other-part container a-container">
        <h1 className="hero-other-title">
          <span className="text-pent">{title}</span>
        </h1>
      </div>
    </div>
  );
}

export default HeroOther;
